var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHonestarFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#07EDC6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#67EFE2;stroke-width:2;stroke-linecap:round;stroke-linejoin:bevel;stroke-miterlimit:10;}\n\t.st3{fill:#4AE3A8;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 74.7,
    cy: 75.1,
    r: 64.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.35
    },
    width: 88,
    height: 87,
    xlinkHref: "277002F31A7DFEDD.png",
    transform: "matrix(1 0 0 1 33.9852 33.6315)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,105.4l1.5-1.5c1-1,1-2.7,0-3.7L56,95.8l-3.8-3.8c-1-1-2.7-1-3.7,0l-1.5,1.5c-4,3.9-6.6,8.9-7.4,14.4      l-0.9,6l6-0.9C50,112,55.1,109.4,58.9,105.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,104.1l0.7-9.6c0.2-3.2,1.5-6.1,3.6-8.5l9.5-10.6c7.9-8.9,12.6-20.2,13.2-32l0.1-3.9      c0.1-1.9-1.5-3.4-3.3-3.3l-4,0.1c-11.9,0.6-23.1,5.3-32,13.2l-10.6,9.5c-2.4,2.1-5.4,3.4-8.5,3.6L48.7,63c-2.1,0.1-4,1.3-5.1,3      l-6.5,10.4c-1.1,1.7-0.6,3.9,1.1,5L59.3,87c2.7,1.7,4.9,4,6.7,6.7l5.3,20.9c1.1,1.7,3.3,2.1,5,1.1l10.4-6.5      C88.5,108,89.6,106.1,89.8,104.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.3,72c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7C85.6,71.3,85.3,71.6,85.3,72       z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,71.9c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6       C85.7,71.4,85.4,71.6,85.4,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,71.9c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5       C85.7,71.5,85.5,71.7,85.5,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6,71.9c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4       C85.8,71.6,85.6,71.7,85.6,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.7,71.9c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3       C85.9,71.6,85.7,71.8,85.7,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.8,71.9c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2       C85.9,71.7,85.8,71.8,85.8,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.9,71.9c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.1C86,71.8,85.9,71.9,85.9,71.9z"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.9,61.3l6.1,2.2l2.9,5.7c0.3,0.5,0.9,0.6,1.3,0.1l4-5.1l6.4-1c0.5-0.1,0.8-0.7,0.5-1.2l-3.6-5.3l1-6.4  c0.1-0.5-0.4-1-1-0.8l-6.2,1.8l-5.7-2.9c-0.5-0.3-1.1,0.1-1.1,0.7l-0.2,6.4l-4.5,4.6C83.3,60.4,83.4,61.1,83.9,61.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonestarFooterLogo);
export default __webpack_public_path__ + "static/media/honestar-footer-logo.9c004d2174c395bb345fa93e339f32b1.svg";
export { ForwardRef as ReactComponent };